import { size } from 'lodash'

import regex from 'helpers/regex'

import cpf from './cpf'
import cnpj from './cnpj'
import hasLetters from './hasLetters'

const isValid = (value) => {
  const document = regex.onlyNumbersAndLetters(value + '')

  if (size(document) > 11 || hasLetters(document)) {
    return cnpj.isValid(document)
  }

  return cpf.isValid(document)
}

export default { isValid }
